import { render } from "./Socials.vue?vue&type=template&id=0b1d7945&scoped=true"
const script = {}

import "./Socials.vue?vue&type=style&index=0&id=0b1d7945&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1d7945"]])

export default __exports__